import { useRecentSplit } from '@tunasong/search'

/**
 * Phase 2 dashboard: returns true when no collaborator-driven edits exist in
 * the current recent feed. Used to suppress last-editor avatars/dots for
 * solo accounts where the indicator carries no signal.
 *
 * Heuristic: empty `theirs` slice + not loading. Will misfire briefly during
 * the first recent-feed fetch (returns false), which is the safe default —
 * we'd rather show the indicator and adjust than hide it spuriously.
 */
export const useIsSoloUser = (): boolean => {
  const { theirs, isLoading } = useRecentSplit()
  if (isLoading) {
    return false
  }
  return theirs.length === 0
}
